module.exports = __webpack_public_path__ + "img/orientation-horizontal-off.2734f265.svg";